(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secureit-blog-hub"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function setup(cat){
      var track = cat.querySelector('.siblog-slider');
      var pager = cat.querySelector('.siblog-cat__pager');
      if(!track || !pager) return;
      var buttons = [];
      function cardsArr(){ return Array.prototype.slice.call(track.querySelectorAll('.siblog-card')); }
      function perView(cards){
        if(!cards.length) return 1;
        var cw = cards[0].getBoundingClientRect().width;
        var gap = cards.length > 1 ? (cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left - cw) : 0;
        return Math.max(1, Math.round(track.clientWidth / (cw + gap)));
      }
      function highlight(cards, per){
        var sl = track.scrollLeft, p = 0;
        for(var i=0;i<buttons.length;i++){ var idx = i*per; if(idx < cards.length && cards[idx].offsetLeft <= sl + 5) p = i; }
        buttons.forEach(function(b,i){ b.classList.toggle('is-active', i === p); });
      }
      function build(){
        var cards = cardsArr(), per = perView(cards);
        var pages = Math.max(1, Math.ceil(cards.length / per));
        pager.innerHTML = ''; buttons = [];
        if(pages <= 1){ pager.style.display = 'none'; return; }
        pager.style.display = '';
        for(var i=0;i<pages;i++){ (function(p){
          var b = document.createElement('button'); b.type = 'button'; b.textContent = p + 1;
          b.addEventListener('click', function(){
            var idx = p * per, target = (idx < cards.length) ? cards[idx].offsetLeft : track.scrollWidth;
            track.scrollTo({ left: target, behavior: 'smooth' });
          });
          pager.appendChild(b); buttons.push(b);
        })(i); }
        highlight(cards, per);
      }
      track.addEventListener('scroll', function(){ var c = cardsArr(); highlight(c, perView(c)); }, { passive: true });
      build();
      var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(build, 150); });
    }
    document.querySelectorAll('.siblog [data-slider]').forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
